var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFboxNoFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 232,
    viewBox: "0 0 212 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5201 17.9951C27.5501 27.8551 5.80005 37.1351 5.80005 38.8751C5.80005 42.9351 98.3101 92.5251 105.85 92.5251C113.68 92.5251 205.9 42.9351 205.9 38.8751C205.9 36.2651 109.04 -0.854858 104.4 0.0151367C103.53 0.0151367 81.2001 8.13514 54.5201 17.9951ZM188.79 38.5851C188.79 40.0351 170.52 51.0551 147.9 62.9451C110.2 82.6651 105.85 84.1151 98.8901 80.9251C91.6401 77.4451 92.8001 76.5751 133.4 55.9851C171.39 36.5551 188.5 31.3351 188.79 38.5851Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03 53.6652C0.87 54.8252 0 79.7652 0 108.765V161.835L12.47 171.695C41.18 194.605 93.38 229.115 97.44 227.665C100.63 226.505 101.5 215.775 101.5 169.375C101.5 137.185 100.34 110.215 98.6 107.025C97.15 104.125 75.98 90.7852 51.62 77.4452C-0.87 48.7352 4.35 51.3452 2.03 53.6652Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 77.7351L114.55 102.965L113.68 167.345C113.39 202.725 113.68 231.725 114.84 231.725C115.71 231.725 137.17 216.645 162.69 198.085C191.4 177.205 209.38 162.125 210.25 158.355C213.15 147.045 210.54 53.9551 207.35 53.0851C205.9 52.7951 184.15 63.8151 159.5 77.7351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFboxNoFrame);
export default __webpack_public_path__ + "static/media/logo-fbox-no-frame.a5947d6ba46e85062e7e003dd1f5087e.svg";
export { ForwardRef as ReactComponent };